module.exports = __webpack_public_path__ + "img/Graph2.41b6601a.png";